module.exports = __webpack_public_path__ + "static/media/pixm-blue-on-white-logo-02@3x.967dde90.png";